/**
 * @file PreviewSkeletonHorizontalCard.tsx
 * @description Enhanced skeleton for PreviewRail with animated gradient
 *
 * Features:
 * - Moving gradient animation with vibrant colors
 * - Blends with standard animate-pulse for subtle shimmer effect
 * - Uses CSS custom properties for smooth color transitions
 */

import type { ReactElement } from "react";
export function PreviewSkeletonHorizontalCard(): ReactElement {
  return (
    <div className="flex-shrink-0 self-start text-left w-[calc(100vw-3rem)] sm:w-[500px] space-y-3 snap-center">
      {/* Landscape image skeleton with moving gradient */}
      <div className="aspect-video rounded-xl overflow-hidden relative bg-neutral-900">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/30 via-purple-800/40 to-pink-900/30" />
      </div>

      {/* Metadata skeleton */}
      <div className="px-1 space-y-2">
        <div className="flex-1 space-y-2">
          <div className="h-5 bg-neutral-800 rounded w-3/4 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />
          </div>
          <div className="space-y-1">
            <div className="h-4 bg-neutral-800 rounded w-1/2 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/20 to-transparent" />
            </div>
            <div className="h-4 bg-neutral-800 rounded w-1/2 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-pink-500/20 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
